module.exports = __webpack_public_path__ + "components/flag/static/square/sn-b6a73aab01b4642d58cb12341ddb8fc1.svg";